<template>
  <div class="night-market-page">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Night Market</div>
      </q-card-section>
      <q-separator />
      
      <div class="night-market-details">
        <div class="time-details">
          Ends at: <span id="time">{{ expiresAt }}</span>
        </div>
      </div>
      <q-card-section class="card-content">
        <div class="col-item" v-for="(column, index) in itemShopColumn" :key="index">
          <item-shop-slot
            v-for="(nightMartketItem) in column"
            :key="nightMartketItem.ID"
            :itemShopInfo="nightMartketItem"
            :isNightMarket="true"
            @success-request="requestGenerateNightMarket()"
          />
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import moment from 'moment'
import ItemShopSlot from '../item-shop/ItemShopSlot';
import { mapGetters, mapActions } from 'vuex';
export default {
  name: 'NightMarketPage',
  data () {
    return {
      tab: '2',
      column: 2,
      pagination: {
        current: 1,
        last: 10
      }
    }
  },
  components: {
    ItemShopSlot
  },
  computed: {
    ...mapGetters({
      getNightMarketItems: 'user/getNightMarketItems',
      getNightMarket: 'user/getNightMarket'
    }),
    itemShopColumn () {
      let column = []

      if (this.getNightMarketItems) {
        const items = this.getNightMarketItems

        if (!items) return []

        const mid = Math.ceil(items.length / this.column)

        for (let col = 0; col < this.column; col++) {
          column.push(items.slice(col * mid, col * mid + mid))
        }
      }

      return column
    },
    expiresAt () {
      if (this.getNightMarket) {
        return moment(new Date(this.getNightMarket)).format('DD MMMM YYYY hh:mm A')
      }

      return 'No Active Night Market!'
    }
  },
	async mounted () {
    await this.recaptchaLoad('generatenightmarket')

    await this.requestGenerateNightMarket ()
	},
	methods: {
		...mapActions({
			generateNightMarket: 'user/generateNightMarket',
      getAuthUser: 'user/getAuthUser'
		}),
    async requestGenerateNightMarket () {
      if (this.getNightMarketItems.length) {
        return
      }

      this.$q.loading.show()

      await this.generateNightMarket()
        .then(async response => {
          await this.getAuthUser()

          this.$q.notify({
            position: 'top-right',
            message: response.data.message,
            type: 'positive'
          })
          
        })
        .catch(error => {
          this.$q.notify({
            position: 'top-right',
            message: error.response.data.message,
            type: 'negative'
          })
        })

      this.$q.loading.hide()
    }
  }
}
</script>

<style lang="scss">
.night-market-page {
  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .search-section {
      color: white;
      background-color: $background;

      .q-input {
        max-width: 300px;
        color: white;
        margin-top: 16px;
        margin-bottom: 48px;
        margin-right: 24px;
        margin-left: auto;
      }

      .q-field__inner {
        height: 0px
      }

      .q-field__native, .q-field__input {
        color: white;
        padding: 14px;
      }
      

      .q-field__control {
        max-height: 48px;
        &::after {
          max-height: 48px;
          color: yellow;
        }
        
        .q-icon {
          color: grey;
        }
      }
    }

    .tab-section {
      background-color: $background;
      color: white;
    }

    .card-section {
      color: white;
    }

    .night-market-details{
      background-color: $background;
      padding: 15px;

      .time-details {
        color: white;
        span {
          color: orange;
        }
      }
    }

    .card-content {
      background-color: $background;
      display: flex;
      grid-template-rows: 1fr 1fr;
      gap: 16px;

      .class-type {
        img {
          width: 50px;
          height: 50px;
        }
      }

      .col-item {
        width: 50%; 
      }
    }

    .pagination {
      padding: 8px;
      background-color: $background;
    }
  }
}
</style>